import { useEffect } from "react";
import { APP_PRICING_URL } from "@/lib/appUrls";

/** Sends visitors to the app pricing/signup page for a seamless handoff. */
const Pricing = () => {
  useEffect(() => {
    window.location.replace(APP_PRICING_URL);
  }, []);

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <p className="text-gray-300 text-lg">Taking you to pricing...</p>
    </div>
  );
};

export default Pricing;
